import { useState } from "react";

export default function Login({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  async function handleSubmit(event) {
    event.preventDefault();
    const body = { username: username.trim(), password: password.trim() };
    const response = await fetch(`https://video-api.vkpublications.com/admin`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) });
    if (response.ok) {
      setError();
      await response.json().then((json) => {
        const name = json.name;
        const userid = json.user_id;

        onLogin({ name, userid });
      });
    } else {
      setError("Invalid username or password");
    }
    //
  }
  return (
    <div className="login-wrapper">
      <div className="login-container">
        <h3>Administrator Login</h3>
        <div style={{ marginTop: 24, marginBottom: 8 }}>
          <form onSubmit={handleSubmit}>
            <div className="input-group" style={{ marginBottom: 12 }}>
              <input type="text" name="username" value={username} onChange={(e) => setUsername(e.target.value)} />
              <label htmlFor="username">Username</label>
            </div>

            <div className="input-group" style={{ marginBottom: 12 }}>
              <input type="password" name="password" value={password} onChange={(e) => setPassword(e.target.value)} />
              <label htmlFor="password">Password</label>
            </div>
            {error && <div style={{ textAlign: "center", color: "red", fontSize: ".85rem" }}>{error}</div>}
            <button className="btn" type="submit">
              Sign In
              <div className="icon">
                <svg height="24" width="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0 0h24v24H0z" fill="none"></path>
                  <path d="M16.172 11l-5.364-5.364 1.414-1.414L20 12l-7.778 7.778-1.414-1.414L16.172 13H4v-2z" fill="currentColor"></path>
                </svg>
              </div>
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
